<app-item-base [open]="open">
  <p class="name" placement="right">
    面談
  </p>
  <div class="edit-field">
    <select class="form-control-select" [(ngModel)]="this.searchParams.interview_times" name="interview_times"
      [ngClass]="{
    'search-active': searchParams.interview_times !== '0'
  }">
      <option value="0" selected="">-</option>
      <ng-container *ngIf="forWorker; else forProjectInterview">
        <option value="1">1〜</option>
        <option value="2">2〜</option>
        <option value="3">3〜</option>
      </ng-container>
      <ng-template #forProjectInterview>
        <option value="1">〜1</option>
        <option value="2">〜2</option>
        <option value="3">〜3</option>
      </ng-template>
    </select>
  </div>
  <input class="edit-field" type="checkbox" placement="right"
    [checked]="!this.searchParams.interview_times_null"
    (change)="this.searchParams.interview_times_null = !this.searchParams.interview_times_null" />

</app-item-base>